import React, { useState, useEffect, useCallback } from 'react'
import {
    ArrowLeft,
    ArrowRight,
    CheckCircle2,
    CreditCard,
    User,
    Smartphone,
    Mail,
    Users,
    Star,
    ChevronDown, Clock,
    Zap, MapPin, Calendar, ShieldCheck,
    ChevronLeft, // Add this
    ChevronRight, // Add this
    CloudCog
} from 'lucide-react'
import Notification from "../../components/Notification";
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; // Suggest adding: npm install framer-motion

import PremiumDatePicker from '../../components/PremiumDatePicker'
import {
    getAllBranch,
    getPackages,
    getAvailableSlots,
    getAddons,
    createBookingApi,
    verifyPaymentApi,
    sendEmailConfirmation,
    getHappyHours,
    sendEmailConfirmationForAdmin
} from '../../api/reusableApis'
import PaymentSuccess from './PaymentSuccess';

const BookingView = ({
    darkMode,
    bookingStep,
    setBookingStep,
    setView,
    selectedDate,
    setSelectedDate,
    userData,
    setUserData
}) => {
    const navigate = useNavigate();
    // --- ADDITIONAL STATE FOR NEW STEPS ---
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [selectedPackage, setSelectedPackage] = useState(null) // { id, name, price, slot }
    const [selectedAddons, setSelectedAddons] = useState([])
    const [celebrantName, setCelebrantName] = useState('')
    const [participants, setParticipants] = useState(1)
    const [locations, setLocations] = useState([])
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [packages, setPackages] = useState([])
    const [activeImageIndex, setActiveImageIndex] = useState({})
    const [selectedTime, setSelectedTime] = useState(null)
    const [slots, setSlots] = useState([]) // New state for slots
    const [addonslist, setAddonsList] = useState([])
    const [bookingDetails, setBookingDetails] = useState({});
    const [happyhours, setHappyhours] = useState({});
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [touched, setTouched] = useState({
        name: false,
        email: false,
        phone: false,
        celebrant: false,
        participants: false
    })
    const [toast, setToast] = useState({ message: "", type: "success" });
    const [expandedPackageId, setExpandedPackageId] = useState(null);

    const markTouched = field => setTouched(prev => ({ ...prev, [field]: true }))
    const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    const isValidPhone = phone => /^[6-9]\d{9}$/.test(phone) // Indian 10-digit mobile
    const fetchdata = useCallback(async () => {
        try {
            const res = await getAllBranch(true)
            setLocations(res || [])
        } catch (err) {
            alert('Failed to load branches')
        } finally {
        }
    }, [])

    const toggleAddon = addon => {
        setSelectedAddons(prev => {
            const exists = prev.some(a => a.ROWID === addon.ROWID)
            if (exists) {
                // remove
                return prev.filter(a => a.ROWID !== addon.ROWID)
            }
            // add
            return [...prev, addon]
        })
    }

    const isLast = bookingStep === 9

    const eventTypes = [
        {
            name: 'Birthday',
            img: 'https://images.unsplash.com/photo-1464349153735-7db50ed83c84?q=80&w=400',
            icon: '🎂'
        },
        {
            name: 'Anniversary',
            img: 'https://images.unsplash.com/photo-1530103043960-ef38714abb15?q=80&w=400',
            icon: '🥂'
        },
        {
            name: 'Bride to be',
            img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=400',
            icon: '👰'
        },
        {
            name: 'Groom to be',
            img: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?q=80&w=500',
            icon: '🤵'
        },
        {
            name: 'Love Proposal',
            img: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?q=80&w=400',
            icon: '❤️'
        },
        {
            name: 'Marriage Proposal',
            img: 'https://images.unsplash.com/photo-1529634597503-139d3726fed5?q=80&w=400',
            icon: '💍'
        },
        {
            name: 'Normal Party',
            img: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=400',
            icon: '🥳'
        }
    ]

    useEffect(() => {
        fetchdata()
    }, [fetchdata])


    const verifyPayment = async (response) => {
        console.log(response, 'response');
        var data = await verifyPaymentApi(response);
        console.log(data, 'data');
        if (data.data.success === true) {
            console.log(data.data?.message);
            navigate(`/payment-success/${response.booking_id}`);
            setPaymentSuccess(true);
            let requestObj = {
                userData: userData,
                booking_id: response.booking_id,
                booking_date: selectedDate,
                package_name: selectedPackage.name,
                timeSlot: selectedTime
            }
            var response = await sendEmailConfirmation(requestObj);
            console.log(response, 'res');

            var responseAdmin = await sendEmailConfirmationForAdmin(requestObj);
            console.log(responseAdmin, 'res');
        } else {
            setToast({
                message: data.data?.message || 'Booking failed..!',
                type: "error",
            });
        }
    }

    // In your booking/payment component
    const handlePayment = async (obj) => {
        console.log(obj, 'obj');
        const options = {
            key: obj.razorKey,
            amount: selectedPackage.advance_amount * 100,
            currency: "INR",
            name: "best surprise Events",
            description: `Advance for ${selectedPackage.name} - ${selectedTime.start_time}`,
            order_id: obj.order_id,
            prefill: {
                name: userData.name,
                contact: userData.phone
            },
            theme: { color: "#72398E" },
            handler: async function (response) {
                // ✅ Payment success → Verify on backend
                let requestData = {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                    booking_id: obj.booking_id,
                    payment_id: obj.payment_id
                }
                await verifyPayment(requestData);
            },
            modal: {
                ondismiss: function () {
                    console.log("Payment cancelled");
                    setToast({
                        message: 'Payment Cancelled..!',
                        type: "error",
                    });
                }
            }
        };
        console.log(options, 'options');
        const rzp = new window.Razorpay(options);
        rzp.open();
    };


    // --- CALCULATIONS ---
    const totalAddonsPrice = selectedAddons.reduce(
        (sum, item) => sum + (item.branches?.[0]?.price || 0),
        0
    )
    const totalPrice = (selectedPackage?.price || 0) + totalAddonsPrice
    // --- VALIDATION ---
    const isNextDisabled =
        (bookingStep === 1 && !selectedLocation) ||
        (bookingStep === 2 && !selectedDate) ||
        (bookingStep === 3 && !selectedEvent) ||
        (bookingStep === 4 && !selectedPackage) ||
        (bookingStep === 5 && !selectedTime) || // ✅ ADD THIS
        (bookingStep === 6 && !userData.cakeNote) ||
        (bookingStep === 8 &&
            (!userData.name?.trim() ||
                !userData.email?.trim() ||
                !isValidEmail(userData.email) ||
                !userData.phone ||
                !isValidPhone(userData.phone)))

    const handleNext = async () => {
        if (bookingStep < 9) {
            setBookingStep(prev => prev + 1)
            if (bookingStep === 3) {
                const res2 = await getPackages(selectedLocation?.Branch_ID, true);

                if (res2 && res2.length > 0) {
                    // Use Promise.all if you want to check Happy Hours for ALL packages in the list
                    const updatedPackages = await Promise.all(res2.map(async (pkg) => {
                        const happyhours = await getHappyHours(pkg.ROWID, true);

                        // Check if happyhours exists and has data
                        if (happyhours && happyhours.length > 0) {
                            const hh = happyhours[0]; // Assuming the first rule applies

                            // Construct the text (e.g., "Happy Hour: Mon-Fri, 09:00 AM - 01:00 PM @ ₹1499")
                            const days = hh.dayOfWeek.map(d => d.substring(0, 3)).join(', ');
                            const hhText = ` (Happy Hour: ${days} ${hh.start_time}-${hh.end_time} @ ₹${hh.override_price})`;

                            return {
                                ...pkg,
                                name: `${pkg.name}`, // Appending to name
                                happyhourstext: `${hhText}`,
                                hasHappyHour: true,
                                override_price: pkg.override_price,
                                hhDetails: hh,
                                dayOfWeek: pkg.dayOfWeek,
                                start_time: pkg.start_time,
                                end_time: pkg.end_time
                            };
                        }
                        return pkg;
                    }));

                    setPackages(updatedPackages);
                } else {
                    setPackages([]);
                }
            } else if (bookingStep === 4) {
                if (selectedPackage && selectedPackage.ROWID) {
                    var happyhours = await getHappyHours(selectedPackage.ROWID, true);
                    if (happyhours[0]?.['is_active']) {
                        setHappyhours(happyhours[0]['is_active']);
                    } else {
                        setHappyhours({});
                    }
                }

                const res2 = await getAvailableSlots(
                    selectedLocation?.Branch_ID,
                    selectedPackage?.ROWID,
                    selectedDate
                );

                // --- SORTING LOGIC START ---
                const sortedSlots = (res2 || []).sort((a, b) => {
                    const timeToMinutes = (timeStr) => {
                        if (!timeStr) return 0;
                        const [time, modifier] = timeStr.split(' ');
                        let [hours, minutes] = time.split(':').map(Number);

                        // Convert to 24-hour format minutes for accurate comparison
                        if (modifier === 'PM' && hours !== 12) hours += 12;
                        if (modifier === 'AM' && hours === 12) hours = 0;

                        return hours * 60 + minutes;
                    };

                    return timeToMinutes(a.start_time) - timeToMinutes(b.start_time);
                });
                // --- SORTING LOGIC END ---
                setSlots(sortedSlots);
            } else if (bookingStep === 6) {
                const response = await getAddons(selectedLocation?.Branch_ID, true)
                setAddonsList(response || [])
            } else if (bookingStep == 8) {

                if (selectedPackage?.hasHappyHour && selectedPackage?.hhDetails) {
                    const hh = selectedPackage.hhDetails;

                    // Helper: Converts "09:00 AM" to minutes (e.g., 540)
                    const timeToMinutes = (timeStr) => {
                        if (!timeStr) return 0;
                        const [time, modifier] = timeStr.split(' ');
                        let [hours, minutes] = time.split(':').map(Number);
                        if (modifier === 'PM' && hours !== 12) hours += 12;
                        if (modifier === 'AM' && hours === 12) hours = 0;
                        return hours * 60 + minutes;
                    };

                    const bookingDay = new Date(selectedDate).toLocaleDateString('en-US', { weekday: 'long' });
                    const isCorrectDay = hh.dayOfWeek.includes(bookingDay);

                    // Convert all times to minutes for comparison
                    const selectedStart = timeToMinutes(selectedTime?.start_time);
                    const selectedEnd = timeToMinutes(selectedTime?.end_time);
                    const hhStart = timeToMinutes(hh.start_time);
                    const hhEnd = timeToMinutes(hh.end_time);

                    // Check if the selected slot is WITHIN the Happy Hour range
                    const isWithinTime = selectedStart >= hhStart && selectedEnd <= hhEnd;

                    if (isCorrectDay && isWithinTime) {
                        setSelectedPackage(prev => ({
                            ...prev,
                            original_price: prev.price,
                            price: hh.override_price
                        }));
                    } else {
                        // REVERT: If conditions don't match, check if we have an original price to go back to
                        if (selectedPackage.original_price) {
                            setSelectedPackage(prev => ({
                                ...prev,
                                price: prev.original_price,
                                original_price: null // Clear it out once reverted
                            }));
                        }
                    }
                }
            }
        } else {
            // REDIRECT TO PAYMENT

            console.log(selectedEvent, 'selectedEvent');
            console.log(selectedLocation, 'selectedLocation');
            console.log(selectedAddons, 'selectedAddons');
            console.log(selectedPackage, 'selectedPackage');
            console.log(selectedDate, 'selectedDate');
            console.log(selectedTime, 'selectedTime');
            console.log(participants, 'participants');
            console.log(userData, 'userData');

            var addonArr = [], addonTotalAmount = 0;
            if (selectedAddons && selectedAddons.length > 0) {
                selectedAddons.forEach((item) => {
                    const price = parseInt(item?.branches?.[0]?.price || 0);
                    addonTotalAmount += price;
                    let obj = {
                        addon_id: item.ROWID,
                        addon_name: item.name,
                        price: price,
                        quantity: 1,
                        line_total: price * 1,
                    }
                    addonArr.push(obj);
                })
            }
            const today = new Date().toLocaleDateString('en-CA', {
                timeZone: 'Asia/Kolkata',
            });


            let requestObj = {
                "branch_id": selectedLocation.Branch_ID,
                "package_id": selectedPackage.ROWID,
                "booking_date": selectedDate,
                "time_slot_id": selectedTime.time_slot_id,
                "customer_name": userData.name,
                "customer_phone": userData.phone,
                "customer_email": userData.email,
                "package_amount": selectedPackage.price,
                "addons_amount": addonTotalAmount,
                "advance_amount": selectedPackage.advance_amount,
                "total_amount": (selectedPackage.price + addonTotalAmount),
                "balance_amount": (selectedPackage.price + addonTotalAmount) - selectedPackage.advance_amount,
                "cake_note": userData.cakeNote,
                "telecaller_id": null,
                "source": "DIRECT",
                "status": "PENDING",
                "notes": '',
                "addons": addonArr || [],
                "created_date": today,
                "eventType": selectedEvent
            }

            const bookings = await createBookingApi(requestObj);
            console.log(bookings, 'booking');
            if (bookings.status === 200) {
                if (bookings.data.success === true) {
                    console.log(bookings.data?.key_id, 'key');
                    console.log(bookings.data?.order?.id, 'orderid');
                    var booking_id = bookings.data.booking?.data[0]['ROWID'];
                    var package_id = bookings.data.newPayments?.data[0]['ROWID'];
                    let obj = {
                        "razorKey": bookings.data?.key_id,
                        "order_id": bookings.data?.order?.id,
                        "booking_id": booking_id,
                        "payment_id": package_id,
                        "booking_date": selectedDate
                    }
                    setBookingDetails(obj);
                    await handlePayment(obj);
                } else {
                    setToast({
                        message: bookings.data?.message || 'Booking failed..!',
                        type: "error",
                    });
                }
            }

            // window.location.href = '/payment-gateway'
        }
        console.log(bookingStep);
    }

    const handleBack = () => {
        console.log("go back");
        window.location.href = '/app/#/customer';
    }

    return (
        <div
            className={`h-screen flex flex-col overflow-hidden transition-colors duration-500 ${darkMode ? 'bg-slate-950 text-white' : 'bg-slate-50 text-slate-900'
                }`}
        >
            <Notification
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ message: "", type: "success" })}
            />

            {/* --- FIXED HEADER --- */}
            <header
                className={`fixed top-0 inset-x-0 z-30 flex-none pt-24 pb-6 px-6 border-b${darkMode ? 'bg-slate-950/80 border-white/5' : 'bg-white/80 border-slate-200'} backdrop-blur-md`}
            >
                <div className='max-w-4xl mx-auto'>
                    <div className='flex gap-2 items-center max-w-2xl mx-auto mb-8'>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(step => (
                            <div
                                key={step}
                                className={`h-1.5 flex-1 rounded-full transition-all duration-500 ${bookingStep >= step
                                    ? 'bg-purple-400 shadow-[0_0_10px_rgba(251,191,36,0.4)]'
                                    : 'bg-slate-800'
                                    }`}
                            />
                        ))}
                    </div>

                    <div className='flex justify-between items-center'>
                        <button
                            onClick={() =>
                                bookingStep === 1
                                    ? setView('landing')
                                    : setBookingStep(b => b - 1)
                            }
                            className='flex items-center gap-2 text-[10px] font-black uppercase tracking-widest opacity-60 hover:opacity-100 transition-all'
                        >
                            <ArrowLeft size={16} /> Back
                        </button>
                        <div className='text-[10px] font-black uppercase tracking-widest text-purple-500'>
                            Step {bookingStep} of 9
                        </div>
                    </div>
                </div>
            </header>

            {/* --- SCROLLABLE CONTENT --- */}
            <main
                className="flex-1 overflow-y-auto custom-scrollbar"
                style={{
                    paddingTop: '180px',
                    paddingBottom: '96px'
                }}
            >
                <div className='max-w-4xl mx-auto px-6 py-5 '>
                    {/* STEP 1: VENUE */}
                    {bookingStep === 1 && (
                        <div className='space-y-6 md:space-y-10 animate-in fade-in slide-in-from-bottom-6 duration-700 max-w-7xl mx-auto px-4 pb-20'>

                            {/* HEADER */}
                            <div className='text-center space-y-2'>
                                <h2 className='text-2xl md:text-3xl lg:text-4xl font-black tracking-tighter italic uppercase'>
                                    Select <span className='text-purple-500'>Venue.</span>
                                </h2>
                                <p className={`text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] ${darkMode ? 'text-slate-400' : 'text-gray-500'}`}>
                                    {locations.length} Locations Available
                                </p>
                            </div>

                            {/* GRID */}
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                {locations.map(loc => {
                                    const isSelected = selectedLocation?.ROWID === loc.ROWID
                                    return (
                                        //                 <div
                                        //                     key={loc.ROWID}
                                        //                     onClick={() => setSelectedLocation(loc)}
                                        //                     className={`group relative cursor-pointer rounded-2xl transition-all duration-300 border
                                        //     ${isSelected
                                        //                             ? 'bg-purple-100 border-purple-400 ring-1 ring-purple-400 shadow-lg scale-[1.02]'
                                        //                             : darkMode
                                        //                                 ? 'bg-slate-900/40 border-white/5 hover:border-purple-400/30'
                                        //                                 : 'bg-white border-gray-100 hover:border-purple-400/30 shadow-sm hover:shadow-md'
                                        //                         }
                                        // `}
                                        //                 >
                                        //                     {/* SELECTION BADGE */}
                                        //                     {isSelected && (
                                        //                         <div className='absolute top-3 right-3 bg-purple-400 text-black p-1 rounded-full z-10 shadow-sm'>
                                        //                             <CheckCircle2 strokeWidth={3} className='w-3.5 h-3.5' />
                                        //                         </div>
                                        //                     )}

                                        //                     {/* IMAGE */}
                                        //                     <div className='p-2'>
                                        //                         <div className='relative h-32 w-full overflow-hidden rounded-xl'>
                                        //                             <img
                                        //                                 src={loc.logo}
                                        //                                 alt={loc.name}
                                        //                                 className='h-full w-full object-cover transition-transform duration-500 group-hover:scale-110'
                                        //                             />
                                        //                             <div className='absolute inset-0 bg-black/5 group-hover:bg-transparent transition-colors' />
                                        //                         </div>
                                        //                     </div>

                                        //                     {/* CONTENT */}
                                        //                     <div className='px-4 pb-5 pt-1 space-y-2'>
                                        //                         <div>
                                        //                             <h3 className={`font-bold uppercase text-sm md:text-base truncate tracking-tight ${isSelected ? 'text-slate-900' : darkMode ? 'text-white' : 'text-slate-900'}`}>
                                        //                                 {loc.name}
                                        //                             </h3>
                                        //                             <div className='h-0.5 w-8 bg-purple-400 mt-1 rounded-full' />
                                        //                         </div>

                                        //                         <div className={`text-[11px] leading-snug space-y-0.5 ${isSelected ? 'text-slate-900' : darkMode ? 'text-slate-400' : 'text-gray-500'}`}>
                                        //                             <p className='font-semibold truncate'>{loc.address1}</p>
                                        //                             <p className='opacity-80 truncate'>{loc.landmark}</p>
                                        //                             <p className='uppercase text-[10px] font-medium tracking-wider'>{loc.city} — {loc.pincode}</p>
                                        //                         </div>

                                        //                         <div className={`flex items-center gap-2 pt-2 border-t ${isSelected ? 'border-purple-300' : 'border-gray-50 dark:border-white/5'}`}>
                                        //                             <span className='opacity-70'>📞</span>
                                        //                             <span className={`text-[11px] font-black tracking-widest ${isSelected ? 'text-purple-700' : darkMode ? 'text-purple-400' : 'text-slate-700'}`}>
                                        //                                 {loc.phone}
                                        //                             </span>
                                        //                         </div>
                                        //                     </div>
                                        //                 </div>

                                        <div
                                            key={loc.ROWID}
                                            onClick={() => setSelectedLocation(loc)}
                                            className={`group relative cursor-pointer rounded-2xl transition-all duration-300 border-2
                                          ${isSelected
                                                    ? 'bg-purple-50 border-purple-400 ring-4 ring-purple-200/50 shadow-2xl scale-[1.02]'
                                                    : darkMode
                                                        ? 'bg-slate-900/50 border-slate-700 hover:border-purple-500 hover:shadow-2xl'
                                                        : 'bg-white/80 border-gray-200 hover:border-purple-400 hover:shadow-2xl hover:shadow-purple-100'
                                                }
                                        `}
                                        >
                                            {/* SELECTION BADGE */}
                                            {isSelected && (
                                                <div className='absolute top-4 right-4 bg-white shadow-lg p-2 rounded-2xl z-20 ring-2 ring-purple-400/50'>
                                                    <CheckCircle2 strokeWidth={2.5} className='w-5 h-5 text-purple-600' />
                                                </div>
                                            )}

                                            {/* IMAGE - Much larger */}
                                            <div className='p-4 pt-3'>
                                                <div className='relative h-48 md:h-56 w-full overflow-hidden rounded-2xl shadow-lg'>
                                                    <img
                                                        src={loc.logo}
                                                        alt={loc.name}
                                                        className='h-full w-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:brightness-110'
                                                        onError={(e) => { e.target.src = '/placeholder-venue.jpg'; }}
                                                    />
                                                    <div className='absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent group-hover:opacity-0 transition-all duration-500' />
                                                </div>
                                            </div>

                                            {/* CONTENT - Better spacing */}
                                            <div className='px-5 pb-6 pt-4 space-y-3'>
                                                {/* NAME + ACCENT */}
                                                <div className='space-y-2'>
                                                    <h3 className={`font-black text-lg md:text-xl leading-tight truncate tracking-tight ${isSelected ? 'text-slate-900 drop-shadow-sm' : darkMode ? 'text-white' : 'text-slate-900'
                                                        }`}>
                                                        {loc.name}
                                                    </h3>
                                                    <div className={`h-1.5 w-12 rounded-full transition-all ${isSelected ? 'bg-purple-500 scale-110 shadow-md' : 'bg-purple-400 group-hover:bg-purple-500'
                                                        }`} />
                                                </div>

                                                {/* ADDRESS */}
                                                <div className={`leading-relaxed space-y-1 ${isSelected ? 'text-slate-800' : darkMode ? 'text-slate-300' : 'text-slate-600'
                                                    }`}>
                                                    <p className='font-semibold text-sm md:text-base line-clamp-1'>{loc.address1}</p>
                                                    {loc.landmark && (
                                                        <p className='text-sm opacity-90 line-clamp-1'>{loc.landmark}</p>
                                                    )}
                                                    <p className='text-xs uppercase font-medium tracking-wider text-purple-600'>
                                                        {loc.city} • {loc.pincode}
                                                    </p>
                                                </div>

                                                {/* PHONE */}
                                                <div className={`flex items-center gap-3 pt-3 border-t-2 ${isSelected
                                                    ? 'border-purple-200 bg-purple-50/50 rounded-xl p-3'
                                                    : 'border-gray-100 dark:border-slate-700/50 group-hover:border-purple-200'
                                                    }`}>
                                                    <div className='p-2 bg-purple-100 rounded-xl group-hover:scale-110 transition-transform'>
                                                        <span className='text-xl'>📞</span>
                                                    </div>
                                                    <span className={`font-black text-base md:text-lg tracking-widest ${isSelected
                                                        ? 'text-purple-700 drop-shadow-sm'
                                                        : darkMode
                                                            ? 'text-purple-400 hover:text-purple-300'
                                                            : 'text-slate-800 hover:text-purple-700'
                                                        }`}>
                                                        {loc.phone}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>



                                    )
                                })}
                            </div>

                            {/* INLINE NAVIGATION BUTTON */}
                            <div className='flex justify-center pt-8 md:pt-12'>
                                <button
                                    disabled={isNextDisabled}
                                    onClick={handleNext}
                                    className={`
                    w-full md:w-auto md:px-20 
                    py-4 md:py-5 
                    rounded-full font-black uppercase tracking-widest 
                    flex items-center justify-center gap-3 
                    transition-all active:scale-[0.98] disabled:opacity-30 
                    shadow-2xl hover:shadow-purple-500/20
                    ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                `}
                                >
                                    Next Step <ArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    )}
                    {/* STEP 2: DATE */}
                    {bookingStep === 2 && (
                        <div className='max-w-sm mx-auto space-y-6 md:space-y-8 text-center animate-in zoom-in-95 duration-500 px-4 pb-12'>
                            {/* HEADER */}
                            <div className='space-y-1.5'>
                                <h2 className='text-2xl md:text-3xl font-black tracking-tighter italic uppercase leading-tight'>
                                    Choose <span className='text-purple-500'>Date.</span>
                                </h2>
                                <p className={`${darkMode ? 'text-slate-400' : 'text-gray-500'} text-[10px] md:text-xs font-bold uppercase tracking-[0.15em]`}>
                                    Select your preferred slot to proceed
                                </p>
                            </div>

                            {/* CALENDAR CONTAINER */}
                            <div className="relative">
                                <div className="scale-95 md:scale-105 origin-top">
                                    <PremiumDatePicker
                                        selectedDate={selectedDate}
                                        onSelect={setSelectedDate}
                                        darkMode={darkMode}
                                        containerClassName="shadow-none border-none bg-transparent"
                                    />
                                </div>
                            </div>

                            {/* HELPER TEXT & NEXT BUTTON */}
                            <div className='space-y-6 pt-4 border-t border-gray-100 dark:border-white/5'>
                                {selectedDate && (
                                    <p className={`text-[11px] font-black uppercase tracking-widest ${darkMode ? 'text-purple-400' : 'text-purple-600'}`}>
                                        Selected: {new Date(selectedDate).toLocaleDateString('en-IN', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                    </p>
                                )}

                                {/* INLINE NAVIGATION BUTTON */}
                                <div className='flex justify-center'>
                                    <button
                                        disabled={isNextDisabled || !selectedDate}
                                        onClick={handleNext}
                                        className={`
                        w-full py-4 md:py-5 
                        rounded-full font-black uppercase tracking-widest 
                        flex items-center justify-center gap-3 
                        transition-all active:scale-[0.98] disabled:opacity-30 
                        shadow-2xl hover:shadow-purple-500/20
                        ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                    `}
                                    >
                                        Next Step <ArrowRight size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* STEP 3: EVENT TYPE */}
                    {bookingStep === 3 && (
                        <div className='space-y-6 md:space-y-8 animate-in fade-in slide-in-from-right-4 duration-500 max-w-7xl mx-auto px-4 pb-12'>
                            {/* HEADER */}
                            <div className='text-center space-y-1'>
                                <h2 className='text-2xl md:text-3xl font-black tracking-tighter italic uppercase'>
                                    The <span className='text-purple-500'>Occasion.</span>
                                </h2>
                                <p className={`${darkMode ? 'text-slate-400' : 'text-gray-500'} text-[10px] md:text-xs font-bold uppercase tracking-[0.2em]`}>
                                    Celebrate your moments
                                </p>
                            </div>

                            {/* GRID */}
                            <div className='grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
                                {eventTypes.map(type => {
                                    const isSelected = selectedEvent === type.name
                                    return (
                                        <button
                                            key={type.name}
                                            onClick={() => setSelectedEvent(type.name)}
                                            className={`group relative h-36 md:h-44 overflow-hidden rounded-2xl md:rounded-3xl transition-all duration-500 ${isSelected
                                                ? 'ring-2 ring-purple-400 scale-[0.98] shadow-lg shadow-purple-400/20'
                                                : 'hover:scale-[1.02] border border-transparent'
                                                }`}
                                        >
                                            {/* Background Image */}
                                            <img
                                                src={type.img}
                                                alt={type.name}
                                                className={`absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ${isSelected ? 'scale-110' : 'group-hover:scale-110'}`}
                                            />

                                            {/* Overlay */}
                                            <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-opacity duration-500 ${isSelected ? 'opacity-100' : 'opacity-60 group-hover:opacity-70'}`} />

                                            {/* Content */}
                                            <div className='absolute inset-0 p-4 flex flex-col justify-end items-start text-left'>
                                                <span className='text-xl mb-1 filter drop-shadow-md'>
                                                    {type.icon}
                                                </span>
                                                <h3 className='text-white font-bold uppercase text-xs md:text-sm leading-none tracking-tight'>
                                                    {type.name}
                                                </h3>

                                                {/* Animated Indicator */}
                                                <div className={`h-1 bg-purple-400 rounded-full transition-all duration-500 mt-2 ${isSelected ? 'w-8' : 'w-0'}`} />
                                            </div>

                                            {/* Selection Checkmark */}
                                            {isSelected && (
                                                <div className='absolute top-3 right-3 bg-purple-400 text-black p-1 rounded-full shadow-lg animate-in zoom-in-50'>
                                                    <CheckCircle2 size={12} strokeWidth={3} />
                                                </div>
                                            )}
                                        </button>
                                    )
                                })}
                            </div>

                            {/* INLINE NAVIGATION BUTTON */}
                            <div className='flex justify-center pt-8 md:pt-10'>
                                <button
                                    disabled={isNextDisabled || !selectedEvent}
                                    onClick={handleNext}
                                    className={`
                    w-full md:w-auto md:px-20 
                    py-4 md:py-5 
                    rounded-full font-black uppercase tracking-widest 
                    flex items-center justify-center gap-3 
                    transition-all active:scale-[0.98] disabled:opacity-30 
                    shadow-2xl hover:shadow-purple-500/20
                    ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                `}
                                >
                                    Next Step <ArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    )}
                    {/* STEP 4: PACKAGES & SLOTS */}
                    {bookingStep === 4 && (
                        <div className='space-y-6 md:space-y-8 animate-in slide-in-from-right-4 duration-500 max-w-7xl mx-auto px-4 pb-16'>
                            {/* Header Section */}
                            <div className='text-center space-y-1'>
                                <h2 className='text-2xl md:text-3xl font-black uppercase tracking-tighter italic'>
                                    Pick <span className='text-purple-500'>Package.</span>
                                </h2>
                                <p className={`text-[10px] md:text-xs font-bold uppercase tracking-widest ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                                    Select a luxury experience
                                </p>
                            </div>

                            {/* Packages Grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch*/}
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                                {packages.map(pkg => {
                                    const features = pkg.description?.split('\n').filter(f => f.trim() !== '') || []
                                    const isSelected = selectedPackage?.ROWID === pkg.ROWID
                                    const isExpanded = expandedPackageId === pkg.ROWID;

                                    const cleanName = pkg.name.trim();
                                    const hasHH = pkg.hasHappyHour && pkg.hhDetails;
                                    const displayPrice = hasHH ? pkg.hhDetails.override_price : pkg.price;
                                    const originalPrice = pkg.price;
                                    const savings = originalPrice - displayPrice;

                                    return (
                                        <div
                                            key={pkg.ROWID}
                                            onClick={() => setSelectedPackage(pkg)}
                                            className={`group relative flex flex-col overflow-hidden rounded-[2rem] border-2 transition-all duration-500 cursor-pointer h-full ${isSelected
                                                ? 'border-purple-400 bg-purple-400/5 shadow-lg'
                                                : darkMode
                                                    ? 'bg-slate-900 border-white/5'
                                                    : 'bg-white border-slate-100 shadow-sm'
                                                }`}
                                        >
                                            {/* Image Section */}
                                            <div className='relative h-40 md:h-48 shrink-0 overflow-hidden bg-slate-800'>
                                                <ImageCarousel images={pkg.images} alt='images'  ></ImageCarousel>
                                            </div>

                                            {/* Details Section */}
                                            <div className='p-5 flex flex-col flex-grow'>
                                                {/* TITLE */}
                                                <div className='mb-3'>
                                                    <h3 className={`text-xl font-black uppercase tracking-tight leading-tight ${isSelected ? 'text-purple-500' : ''}`}>
                                                        {cleanName}
                                                    </h3>
                                                </div>

                                                {/* DISCOUNT CARD DESIGN */}
                                                {hasHH ? (
                                                    <div className="relative mb-5 p-4 rounded-2xl bg-gradient-to-br from-amber-400 to-purple-500 text-black shadow-inner overflow-hidden border-2 border-dashed border-amber-600/30">
                                                        <div className="absolute -left-2 top-1/2 -translate-y-1/2 w-4 h-4 bg-white dark:bg-slate-900 rounded-full"></div>
                                                        <div className="absolute -right-2 top-1/2 -translate-y-1/2 w-4 h-4 bg-white dark:bg-slate-900 rounded-full"></div>

                                                        <div className="flex justify-between items-start mb-2">
                                                            <div className="flex items-center gap-1.5">
                                                                <Clock size={14} className="animate-pulse" />
                                                                <span className="text-[10px] font-black uppercase tracking-wider text-black/80">Happy Hour Deal</span>
                                                            </div>
                                                            <span className="bg-black text-white text-[10px] font-black px-2 py-0.5 rounded-lg shadow-sm">
                                                                SAVE ₹{savings}
                                                            </span>
                                                        </div>

                                                        <div className="flex flex-col">
                                                            <div className="flex items-baseline gap-2">
                                                                <span className="text-3xl font-black">₹{displayPrice}</span>
                                                                <span className="text-sm font-bold opacity-60 line-through decoration-black/50">₹{originalPrice}</span>
                                                            </div>
                                                            <span className="text-[10px] font-bold mt-2 leading-tight uppercase tracking-tighter opacity-90">
                                                                {pkg.hhDetails.start_time} - {pkg.hhDetails.end_time}
                                                            </span>
                                                            <span className="text-[9px] font-medium opacity-80 italic">
                                                                {pkg.hhDetails.dayOfWeek.join(', ')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='mb-4'>
                                                        <p className='text-3xl font-black text-purple-500'>₹{pkg.price}</p>
                                                    </div>
                                                )}

                                                {/* Features Wrapper */}
                                                <div className="flex-grow space-y-2">
                                                     <div className='min-h-[85px] space-y-2'>
                                                        {features.slice(0, 3).map((feature, idx) => (
                                                            <div key={idx} className='flex items-start gap-2'>
                                                                <CheckCircle2 size={12} className="text-purple-500 mt-0.5 shrink-0" />
                                                                <span className={`text-[11px] font-medium leading-tight line-clamp-2 ${darkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                                                                    {feature}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div> 

                                                    <div className={`grid transition-all duration-300 ease-in-out ${isExpanded ? 'grid-rows-[1fr] opacity-100 mt-2' : 'grid-rows-[0fr] opacity-0'}`}>
                                                        <div className="overflow-hidden space-y-2">
                                                            {features.map((feature, idx) => (
                                                                <div key={idx + 3} className='flex items-start gap-2'>
                                                                    <CheckCircle2 size={12} className="text-purple-500 mt-0.5 shrink-0" />
                                                                    <span className={`text-[11px] font-medium leading-tight ${darkMode ? 'text-slate-400' : 'text-slate-600'}`}>
                                                                        {feature}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setExpandedPackageId(isExpanded ? null : pkg.ROWID);
                                                        }}
                                                        className="flex items-center gap-1 text-[10px] font-black uppercase tracking-tighter text-purple-500 mt-2"
                                                    >
                                                        {isExpanded ? 'Show Less' : `+ ${features.length - 3} More Info`}
                                                        <ChevronDown size={12} className={`transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
                                                    </button>
                                                </div>

                                                <div className={`text-[9px] font-black uppercase tracking-widest pt-4 border-t mt-4 border-gray-100 dark:border-white/5 ${isSelected ? 'text-purple-500' : 'opacity-40'}`}>
                                                    {isSelected ? '✓ Selected' : 'Click to select'}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            {/* INLINE NAVIGATION BUTTON */}
                            <div className='flex justify-center pt-5'>
                                <button
                                    disabled={isNextDisabled || !selectedPackage}
                                    onClick={handleNext}
                                    className={`
                    w-full md:w-auto md:px-24 
                    py-4 md:py-5 
                    rounded-full font-black uppercase tracking-widest 
                    flex items-center justify-center gap-3 
                    transition-all active:scale-[0.98] disabled:opacity-30 
                    shadow-2xl hover:shadow-purple-500/20
                    ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                `}
                                >
                                    Next Step <ArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    )}
                    {/* STEP 4: TIME SLOT (THE NEW SCREEN) */}
                    {bookingStep === 5 && (
                        <div className='space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-2xl mx-auto px-4 pb-16'>
                            <div className='text-center'>
                                <h2 className='text-3xl font-black italic tracking-tighter uppercase'>
                                    Select <span className='text-purple-500'>Time.</span>
                                </h2>
                                <p className={`text-[10px] font-bold uppercase tracking-[0.2em] mt-2 ${darkMode ? 'text-slate-400' : 'text-gray-500'}`}>
                                    Available slots for your surprise
                                </p>
                            </div>

                            <div className='grid grid-cols-2 sm:grid-cols-3 gap-3'>
                                {slots.map(s => {
                                    const isSelected = selectedTime?.label === s.label;
                                    const isAvailable = s.is_available;

                                    return (
                                        <button
                                            key={s.time_slot_id}
                                            disabled={!isAvailable}
                                            onClick={() => setSelectedTime(s)}
                                            className={`group relative py-4 px-2 rounded-2xl border-2 transition-all flex flex-col items-center justify-center overflow-hidden ${!isAvailable
                                                ? 'bg-slate-100 border-slate-200 text-slate-400 cursor-not-allowed'
                                                : isSelected
                                                    ? 'border-purple-400 bg-purple-400 shadow-lg shadow-purple-400/20 scale-[1.05] z-10'
                                                    : darkMode
                                                        ? 'bg-slate-900 border-slate-800 text-slate-400 hover:border-slate-600'
                                                        : 'bg-white border-slate-100 text-slate-500 shadow-sm hover:shadow-md'
                                                }`}
                                        >
                                            {/* Start Time */}
                                            <span className={`text-base font-black leading-tight transition-colors ${isSelected ? 'text-indigo-950' : 'text-current'}`}>
                                                {s.start_time}
                                            </span>

                                            {/* End Time */}
                                            <span className={`text-[9px] font-bold uppercase tracking-tighter opacity-70 transition-colors ${isSelected ? 'text-indigo-900' : 'text-current'}`}>
                                                to {s.end_time}
                                            </span>

                                            {/* Selection icon */}
                                            {isSelected && (
                                                <div className='absolute top-1 right-1'>
                                                    <CheckCircle2 size={10} className='text-indigo-950' />
                                                </div>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* INLINE NAVIGATION BUTTON */}
                            <div className='flex justify-center pt-10'>
                                <button
                                    disabled={isNextDisabled}
                                    onClick={handleNext}
                                    className={`
                    w-full py-4 md:py-5 
                    rounded-full font-black uppercase tracking-widest 
                    flex items-center justify-center gap-3 
                    transition-all active:scale-[0.98] disabled:opacity-30 
                    shadow-2xl hover:shadow-purple-500/20
                    ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                `}
                                >
                                    Next Step <ArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    )}

                    {/* STEP 6: CAKE-NAME */}
                    {bookingStep === 6 && (
                        <div className='max-w-5xl mx-auto px-4 py-8 animate-in fade-in zoom-in-95 duration-700 pb-16'>
                            {/* HEADER */}
                            <div className='text-center mb-10 space-y-1'>
                                <h2 className='text-3xl md:text-4xl font-black uppercase tracking-tighter italic leading-none'>
                                    Personalize <span className='text-purple-600'>Cake.</span>
                                </h2>
                                <p className='text-[10px] md:text-xs font-bold opacity-60 uppercase tracking-[0.2em]'>
                                    Handwritten with purple velvet icing
                                </p>
                            </div>

                            {/* TWO-COLUMN LAYOUT */}
                            <div className='flex flex-col md:flex-row items-center justify-center gap-10 lg:gap-24 mb-12'>

                                {/* LEFT: CAKE PREVIEW & MESSAGE DISPLAY */}


                                {/* RIGHT: INPUT CONTROLS */}
                                <div className='w-full max-w-sm space-y-6'>
                                    <div className='space-y-4'>
                                        <div className='flex justify-between items-end px-2'>
                                            <label className='text-[10px] font-black uppercase tracking-widest opacity-50'>
                                                Message on Cake
                                            </label>
                                            <span className={`text-[10px] font-black tabular-nums ${(userData.cakeNote?.length || 0) >= 55 ? 'text-purple-600' : 'opacity-30'}`}>
                                                {userData.cakeNote?.length || 0}/60
                                            </span>
                                        </div>

                                        <div className={`relative rounded-[2.5rem] p-1.5 transition-all duration-500 group/input ${darkMode ? 'bg-slate-900 border border-white/10' : 'bg-white border border-slate-200 shadow-xl'
                                            } ${userData.cakeNote ? 'ring-2 ring-purple-500/30' : ''}`}>
                                            <textarea
                                                rows='3'
                                                maxLength={60}
                                                placeholder='Happy Birthday...'
                                                className={`w-full px-6 py-8 bg-transparent outline-none text-center text-lg md:text-xl font-bold resize-none placeholder:opacity-20 ${darkMode ? 'text-white' : 'text-slate-800'
                                                    }`}
                                                value={userData.cakeNote || ''}
                                                onChange={e => setUserData({ ...userData, cakeNote: e.target.value })}
                                            />

                                            {/* purple Progress Bar */}
                                            <div className='absolute bottom-6 left-12 right-12 h-1 bg-slate-100 dark:bg-white/5 rounded-full overflow-hidden'>
                                                <div
                                                    className='h-full bg-purple-600 transition-all duration-300'
                                                    style={{ width: `${((userData.cakeNote?.length || 0) / 60) * 100}%` }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* INLINE NAVIGATION BUTTON */}
                            <div className='flex justify-center'>
                                <button
                                    disabled={isNextDisabled}
                                    onClick={handleNext}
                                    className={`
                    w-full md:w-auto md:px-24 
                    py-4 md:py-5 
                    rounded-full font-black uppercase tracking-widest 
                    flex items-center justify-center gap-3 
                    transition-all active:scale-[0.98] disabled:opacity-30 
                    shadow-2xl hover:shadow-purple-500/20
                    ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                `}
                                >
                                    Next Step <ArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    )}

                    {/* STEP 7: ADDONS */}
                    {bookingStep === 7 && (
                        <div className='max-w-7xl mx-auto space-y-8 animate-in fade-in slide-in-from-right-4 duration-500 px-4 pb-20'>
                            {/* HEADER */}
                            <div className='text-center'>
                                <h2 className='text-2xl md:text-3xl font-black uppercase tracking-tighter italic'>
                                    Extra <span className='text-purple-500'>Addons.</span>
                                </h2>
                                <p className='text-[10px] md:text-xs font-bold uppercase tracking-[0.2em] opacity-50 mt-1'>
                                    Enhance your experience (Select multiple)
                                </p>
                            </div>

                            {/* Add-ons Grid */}
                            <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6'>
                                {addonslist.map(addon => {
                                    const price = addon.branches?.[0]?.price || 0
                                    const imageUrl =
                                        addon.images?.[0]?.url ||
                                        'https://images.unsplash.com/photo-1513151233558-d860c5398176?q=80&w=400'
                                    const isSelected = selectedAddons.find(
                                        a => a.ROWID === addon.ROWID
                                    )

                                    return (
                                        <div
                                            key={addon.ROWID}
                                            onClick={() => toggleAddon(addon)}
                                            className={`group relative aspect-[4/5] rounded-[1.5rem] md:rounded-[2rem] overflow-hidden border-2 md:border-4 transition-all duration-300 cursor-pointer ${isSelected
                                                ? 'border-purple-400 scale-[0.98] shadow-lg shadow-purple-400/20'
                                                : darkMode
                                                    ? 'border-white/5 opacity-80 hover:opacity-100'
                                                    : 'border-slate-100 opacity-90 shadow-sm hover:shadow-md'
                                                }`}
                                        >
                                            <img
                                                src={imageUrl}
                                                alt={addon.name}
                                                className='absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110'
                                            />

                                            <div className='absolute inset-0 bg-gradient-to-t from-black/95 via-black/30 to-transparent' />

                                            <div className='absolute top-3 right-3 z-20'>
                                                {isSelected ? (
                                                    <div className='bg-purple-400 text-slate-950 p-1 rounded-full shadow-lg'>
                                                        <CheckCircle2 size={14} strokeWidth={3} />
                                                    </div>
                                                ) : (
                                                    <div className='bg-black/40 backdrop-blur-md text-white text-[9px] font-black px-2 py-1 rounded-lg border border-white/20'>
                                                        ₹{price}
                                                    </div>
                                                )}
                                            </div>

                                            <div className='absolute bottom-0 left-0 right-0 p-3 md:p-4 z-10'>
                                                <h4 className='text-white font-bold text-[11px] md:text-xs leading-tight uppercase tracking-tight mb-1 truncate'>
                                                    {addon.name}
                                                </h4>
                                                <p className='text-[9px] text-white/50 font-medium line-clamp-1 leading-relaxed'>
                                                    {addon.description}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            {/* SUMMARY BAR */}
                            <div className='max-w-2xl mx-auto pt-4 space-y-8'>
                                <div
                                    className={`p-4 md:p-6 rounded-[2rem] border-2 transition-all flex justify-between items-center ${selectedAddons.length > 0
                                        ? 'border-purple-400 bg-purple-400/5'
                                        : darkMode
                                            ? 'border-white/5 bg-slate-900/50'
                                            : 'border-slate-100 bg-slate-50'
                                        }`}
                                >
                                    <div className='space-y-0.5'>
                                        <p className='text-[9px] font-black uppercase tracking-widest opacity-40'>
                                            Extras Selected
                                        </p>
                                        <p className='text-base md:text-xl font-black'>
                                            {selectedAddons.length} <span className='text-sm opacity-50 font-medium uppercase'>Items</span>
                                        </p>
                                    </div>
                                    <div className='text-right space-y-0.5'>
                                        <p className='text-[9px] font-black uppercase tracking-widest opacity-40'>
                                            Additional Cost
                                        </p>
                                        <p className='text-xl md:text-2xl font-black text-purple-500'>
                                            ₹{selectedAddons.reduce((sum, a) => sum + (a.branches?.[0]?.price || 0), 0)}
                                        </p>
                                    </div>
                                </div>

                                {/* INLINE NAVIGATION BUTTON */}
                                <div className='flex justify-center'>
                                    <button
                                        disabled={isNextDisabled}
                                        onClick={handleNext}
                                        className={`
                        w-full py-4 md:py-5 
                        rounded-full font-black uppercase tracking-widest 
                        flex items-center justify-center gap-3 
                        transition-all active:scale-[0.98] disabled:opacity-30 
                        shadow-2xl hover:shadow-purple-500/20
                        ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                    `}
                                    >
                                        {selectedAddons.length > 0 ? 'Add & Continue' : 'Skip & Continue'} <ArrowRight size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* STEP 8: DETAILS */}
                    {bookingStep === 8 && (
                        <div className='max-w-md mx-auto space-y-8 animate-in zoom-in-95 duration-500 px-4 pb-16'>
                            {/* HEADER */}
                            <div className='text-center space-y-1'>
                                <h2 className='text-2xl md:text-3xl font-black uppercase tracking-tighter italic'>
                                    Contact <span className='text-purple-500'>Details.</span>
                                </h2>
                                <p className={`text-[10px] md:text-xs font-bold uppercase tracking-widest opacity-50`}>
                                    Almost there! Enter your info
                                </p>
                            </div>

                            <div className='space-y-4'>
                                {/* NAME */}
                                <div className='relative group'>
                                    <User size={20} className='absolute left-5 top-1/2 -translate-y-1/2 opacity-30 group-focus-within:text-purple-500 group-focus-within:opacity-100 transition-all' />
                                    <input
                                        placeholder='Your Name'
                                        className={`w-full pl-14 pr-6 py-4 rounded-2xl border-2 outline-none font-bold transition-all
                        ${darkMode
                                                ? touched.name && !userData.name
                                                    ? 'bg-slate-900 border-red-500 text-white'
                                                    : 'bg-slate-900 border-white/5 focus:border-purple-400 text-white'
                                                : touched.name && !userData.name
                                                    ? 'bg-white border-red-500'
                                                    : 'bg-white border-slate-100 focus:border-purple-400 shadow-sm'
                                            }`}
                                        value={userData.name}
                                        onChange={e => setUserData({ ...userData, name: e.target.value })}
                                        onBlur={() => markTouched('name')}
                                    />
                                    {touched.name && !userData.name && (
                                        <p className='text-[9px] font-black text-red-500 pl-5 mt-1'>Name is required</p>
                                    )}
                                </div>

                                {/* EMAIL */}
                                <div className='relative group'>
                                    <Mail size={20} className='absolute left-5 top-1/2 -translate-y-1/2 opacity-30 group-focus-within:text-purple-500 group-focus-within:opacity-100 transition-all' />
                                    <input
                                        type='email'
                                        placeholder='Email Address'
                                        className={`w-full pl-14 pr-6 py-4 rounded-2xl border-2 outline-none font-bold transition-all
                        ${darkMode
                                                ? touched.email && !isValidEmail(userData.email || '')
                                                    ? 'bg-slate-900 border-red-500 text-white'
                                                    : 'bg-slate-900 border-white/5 focus:border-purple-400 text-white'
                                                : touched.email && !isValidEmail(userData.email || '')
                                                    ? 'bg-white border-red-500'
                                                    : 'bg-white border-slate-100 focus:border-purple-400 shadow-sm'
                                            }`}
                                        value={userData.email || ''}
                                        onChange={e => setUserData({ ...userData, email: e.target.value })}
                                        onBlur={() => markTouched('email')}
                                    />
                                    {touched.email && !isValidEmail(userData.email || '') && (
                                        <p className='text-[9px] font-black text-red-500 pl-5 mt-1'>Enter a valid email</p>
                                    )}
                                </div>

                                {/* PHONE */}
                                <div className='relative group'>
                                    <Smartphone size={20} className='absolute left-5 top-1/2 -translate-y-1/2 opacity-30 group-focus-within:text-purple-500 group-focus-within:opacity-100 transition-all' />
                                    <input
                                        placeholder='Phone Number'
                                        className={`w-full pl-14 pr-6 py-4 rounded-2xl border-2 outline-none font-bold transition-all
                        ${darkMode
                                                ? touched.phone && !isValidPhone(userData.phone || '')
                                                    ? 'bg-slate-900 border-red-500 text-white'
                                                    : 'bg-slate-900 border-white/5 focus:border-purple-400 text-white'
                                                : touched.phone && !isValidPhone(userData.phone || '')
                                                    ? 'bg-white border-red-500'
                                                    : 'bg-white border-slate-100 focus:border-purple-400 shadow-sm'
                                            }`}
                                        value={userData.phone}
                                        onChange={e => setUserData({ ...userData, phone: e.target.value })}
                                        onBlur={() => markTouched('phone')}
                                    />
                                </div>

                                {/* INLINE NAVIGATION BUTTON */}
                                <div className='pt-6'>
                                    <button
                                        disabled={isNextDisabled || !userData.name || !isValidEmail(userData.email || '') || !isValidPhone(userData.phone || '')}
                                        onClick={handleNext}
                                        className={`
                        w-full py-4 md:py-5 
                        rounded-full font-black uppercase tracking-widest 
                        flex items-center justify-center gap-3 
                        transition-all active:scale-[0.98] disabled:opacity-30 
                        shadow-2xl hover:shadow-purple-500/20
                        ${darkMode ? 'bg-purple-500 text-white' : 'bg-purple-600 text-white'}
                    `}
                                    >
                                        Review Summary <ArrowRight size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* STEP 8: Preview */}
                    {bookingStep === 9 && (
                        <div className='max-w-5xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-700 px-4 pb-20'>
                            <div className={`w-full overflow-hidden rounded-[2.5rem] transition-all duration-300 shadow-2xl border ${darkMode ? 'bg-slate-950 text-white border-white/10' : 'bg-white text-slate-950 border-slate-200'
                                }`}>

                                {/* 1. Header Section */}
                                <div className='px-8 py-6 border-b border-gray-100 dark:border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4'>
                                    <div className='flex items-center gap-4'>
                                        <div className='h-12 w-12 rounded-2xl bg-purple-500 flex items-center justify-center text-white shadow-lg shadow-purple-500/20 rotate-3'>
                                            <CreditCard size={24} strokeWidth={2.5} />
                                        </div>
                                        <div>
                                            <h2 className='text-[10px] uppercase tracking-[0.3em] font-black text-purple-500 leading-none mb-1'>
                                                Final Step
                                            </h2>
                                            <h3 className='text-2xl font-black tracking-tight italic uppercase'>Review <span className='text-purple-500'>& Pay.</span></h3>
                                        </div>
                                    </div>

                                    {/* Status Badges */}
                                    <div className='flex gap-2'>
                                        {selectedPackage?.original_price && (
                                            <div className="bg-amber-500 text-black px-3 py-1 rounded-full flex items-center gap-1.5 shadow-lg shadow-amber-500/20">
                                                <Zap size={10} fill="currentColor" />
                                                <p className='text-[9px] font-black uppercase tracking-widest'>Happy Hour Applied</p>
                                            </div>
                                        )}
                                        <div className='bg-emerald-500/10 border border-emerald-500/20 px-3 py-1 rounded-full'>
                                            <p className='text-[9px] font-black uppercase tracking-widest text-emerald-500'>Secure Session</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-col lg:flex-row'>
                                    {/* 2. LEFT COLUMN: The Details */}
                                    <div className='flex-1 p-8 space-y-8'>
                                        {/* Booking Basics */}
                                        <div className='grid grid-cols-1 sm:grid-cols-3 gap-6'>
                                            {[
                                                { label: 'Venue', value: selectedLocation?.name, icon: <MapPin size={14} /> },
                                                { label: 'Date', value: selectedDate ? new Date(selectedDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : 'N/A', icon: <Calendar size={14} /> },
                                                { label: 'Time Slot', value: `${selectedTime?.start_time} - ${selectedTime?.end_time}`, icon: <Clock size={14} /> }
                                            ].map((item, i) => (
                                                <div key={i} className='space-y-1'>
                                                    <span className='text-[9px] uppercase font-black tracking-widest opacity-40 flex items-center gap-1.5'>
                                                        {item.icon} {item.label}
                                                    </span>
                                                    <p className='text-sm font-black uppercase'>{item.value}</p>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Personalization Section */}
                                        <div className='bg-slate-50 dark:bg-white/5 rounded-3xl p-6 border border-dashed border-slate-200 dark:border-white/10'>
                                            <div className='flex items-center gap-2 mb-4'>
                                                <span className='text-[10px] uppercase font-black tracking-widest text-purple-500'>Personalization</span>
                                                <div className='h-px flex-1 bg-gradient-to-r from-purple-500/20 to-transparent' />
                                            </div>

                                            {userData.cakeNote?.trim() ? (
                                                <p className='text-xl md:text-2xl font-serif italic text-purple-700 dark:text-purple-400 leading-tight'>
                                                    "{userData.cakeNote}"
                                                </p>
                                            ) : (
                                                <p className='text-xs font-bold opacity-30 italic uppercase tracking-widest'>No message provided for the cake</p>
                                            )}
                                        </div>

                                        {/* Contact Info Preview */}
                                        <div className='flex gap-6 pt-4'>
                                            <div className='flex-1'>
                                                <span className='text-[9px] uppercase font-black tracking-widest opacity-40 block mb-1'>Customer</span>
                                                <p className='text-sm font-bold'>{userData.name}</p>
                                            </div>
                                            <div className='flex-1'>
                                                <span className='text-[9px] uppercase font-black tracking-widest opacity-40 block mb-1'>Contact</span>
                                                <p className='text-sm font-bold'>{userData.phone}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 3. RIGHT COLUMN: The Invoice */}
                                    <div className={`w-full lg:w-[380px] p-8 ${darkMode ? 'bg-white/[0.03]' : 'bg-slate-50'}`}>
                                        <h4 className='text-[10px] uppercase font-black tracking-[0.2em] opacity-40 mb-6'>Order Summary</h4>

                                        <div className='space-y-4 mb-8'>
                                            {/* Package Row */}
                                            <div className='flex justify-between items-start'>
                                                <div className='max-w-[180px]'>
                                                    <p className='text-xs font-black uppercase truncate'>{selectedPackage?.name}</p>
                                                    <p className='text-[10px] opacity-50 font-bold uppercase'>Base Package</p>
                                                </div>
                                                <div className='text-right'>
                                                    <p className='text-sm font-black'>₹{selectedPackage?.price}</p>
                                                    {selectedPackage?.original_price && (
                                                        <p className='text-[10px] opacity-40 line-through font-bold'>₹{selectedPackage.original_price}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Addons List */}
                                            {selectedAddons.map(addon => (
                                                <div key={addon.ROWID} className='flex justify-between items-center'>
                                                    <p className='text-[11px] font-bold opacity-70 uppercase truncate max-w-[180px]'>{addon.name}</p>
                                                    <p className='text-[11px] font-black text-purple-500'>+₹{addon.branches?.[0]?.price || 0}</p>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Total Block */}
                                        <div className='border-t-2 border-dashed border-slate-200 dark:border-white/10 pt-6 mb-8'>
                                            <div className='flex justify-between items-end'>
                                                <div>
                                                    <p className='text-[10px] font-black uppercase tracking-widest opacity-40 mb-1'>Total Amount</p>
                                                    <p className='text-4xl font-black tracking-tighter text-purple-500'>₹{totalPrice}</p>
                                                </div>
                                                <div className='text-right'>
                                                    <p className='text-[9px] font-black uppercase tracking-widest text-emerald-500 mb-1'>Advance Due</p>
                                                    <p className='text-xl font-black'>₹{selectedPackage?.advance_amount || (totalPrice * 0.5)}</p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* PAY BUTTON */}
                                        <button
                                            onClick={handleNext}
                                            className="w-full bg-purple-600 hover:bg-purple-500 text-white py-5 rounded-[2rem] font-black uppercase tracking-[0.2em] flex items-center justify-center gap-3 transition-all active:scale-[0.98] shadow-xl shadow-purple-600/20 group"
                                        >
                                            Confirm & Pay <ArrowRight size={20} className='group-hover:translate-x-1 transition-transform' />
                                        </button>

                                        <p className='text-center mt-4 text-[9px] font-black uppercase tracking-widest opacity-30'>
                                            Fully Refundable up to 48hrs before
                                        </p>
                                    </div>
                                </div>

                                {/* Footer Brand */}
                                <div className='bg-slate-900 dark:bg-white py-3 flex items-center justify-center gap-2'>
                                    <ShieldCheck size={14} className='text-purple-400' />
                                    <p className='text-white dark:text-slate-950 text-[10px] font-black uppercase tracking-[0.2em]'>
                                        Secure 256-bit SSL Encryption
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* 
                    {bookingStep === 10 && (<PaymentSuccess details={bookingDetails} onGoBack={handleBack} amount={selectedPackage.advance_amount} userData={userData} />)} */}
                </div>
            </main>

        </div>
    )
}


const ImageCarousel = ({ images, alt }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!images || images.length <= 1) return;
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
        }, 2000);
        return () => clearInterval(timer);
    }, [currentIndex, images?.length]);

    if (!images || images.length === 0) return <div className="h-full w-full bg-slate-800" />;

    const nextSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    return (
        <div className="relative h-full w-full overflow-hidden">
            <AnimatePresence mode="wait">
                <motion.img
                    key={currentIndex}
                    src={images[currentIndex]?.url}
                    alt={alt}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="h-full w-full object-cover"
                />
            </AnimatePresence>

            {images.length > 1 && (
                <>
                    {/* Navigation Arrows - Now permanently visible */}
                    <button
                        onClick={prevSlide}
                        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 backdrop-blur-md p-1.5 rounded-full text-white transition-transform active:scale-90 hover:bg-black/60"
                    >
                        <ChevronLeft size={18} />
                    </button>
                    <button
                        onClick={nextSlide}
                        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-black/40 backdrop-blur-md p-1.5 rounded-full text-white transition-transform active:scale-90 hover:bg-black/60"
                    >
                        <ChevronRight size={18} />
                    </button>

                    {/* Indicators */}
                    <div className="absolute bottom-3 left-0 right-0 z-10 flex justify-center gap-1.5">
                        {images.map((_, i) => (
                            <button
                                key={i}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentIndex(i);
                                }}
                                className={`h-1.5 rounded-full transition-all duration-300 ${i === currentIndex ? 'w-6 bg-purple-400' : 'w-1.5 bg-white/50'
                                    }`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default BookingView
